<template>
  <v-card class="hot-wrapper" flat style="min-height::90vh;">
    <v-container style="padding:28px;">
     <notifications group="messageArea"
               position="bottom left"
               :speed="500" /> 
      <v-flex xs12 style="margin-top:30px;">
      <h3>
        パスワードリセット
      </h3>
      <p>
        <ol>
          <li>ご利用中のメールアドレスを入力して「送信」ボタンをクリック</li>
          <li>パスワード再設定リンクが記載されたメールが届きます</li>
          <li>リンクから再設定ページへ</li>
        </ol>
      </p>
        <v-form ref="userEntry" v-model="valid">
          <v-layout row wrap>
            <v-text-field label="メールアドレスを入力してください" v-model="mail"
              :rules="[rules.required, rules.email, rules.max]"
            ></v-text-field>
          </v-layout>
        </v-form>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-btn dark :disabled="isDisabled" color="primary" @click="onSend">パスワード再設定リンクを送信</v-btn>
          <v-spacer></v-spacer>
        </v-layout>
        <v-flex xs12 style="text-align:center"><router-link :to="{name: 'login'}">ログインはこちら</router-link></v-flex>
      </v-flex>
    </v-container>
  </v-card>
</template>

<script>
import { auth } from '../../main'
// @ is an alias to /src
export default {
  name: 'Login',
  data () {
    return {
      mail: '',
      valid: '',
      isDisabled: false,
      rules: {
        required: v => !!v || '必須項目です。',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'メールアドレスの形式が誤っています。'
        },
        min: v => {
          return v.length >= 8 || '8文字以上入力してください。'
        },
        max: v => {
          return v.length <= 80 || '入力できるのは40文字以下です。'
        },
        password: v => {
          let p = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/
          return p.test(v) || '半角英大文字、英小文字、数字を1文字以上含めてください。'
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    onSend () {
      this.$refs.userEntry.validate()
      if (this.valid) {
        this.sendResetLink()
      } else {
        this.$notify({
            group: 'messageArea',
            type: 'warning',
            title: '入力エラー',
            text: 'エラーメッセージを確認して修正をお願いします。'
          });
      }
    },
    sendResetLink () {
      var emailAddress = this.mail
      auth.sendPasswordResetEmail(emailAddress).then(() => {
      // Email sent.
        this.$notify({
            group: 'messageArea',
            type: 'info',
            text: 'メールアドレスにパスワード再設定用リンクを送信しました。メールを確認してください。'
          });
          this.isDisabled = true
      }).catch((error) => {
        this.$notify({
            group: 'messageArea',
            type: 'warning',
            title: 'エラー',
            text: 'メールアドレスが登録されていません。'
          });
        console.log(error)
      })

    }
  },
  components: {
  }
}
</script>
<style scoped>
</style>
